export default __webpack_public_path__ + "static/media/plan.bb29eb1e.svg";